import { computeAccrualLineAmount } from "@common/helpers/accrual-line-item-amount.helper";
import { AccrualImporterRow } from "./types";

export function isAmountDrivingAccrualField(
    field: string,
): field is "quantity" | "unitPrice" {
    return field === "quantity" || field === "unitPrice";
}

export function withDerivedAccrualLineAmount(
    row: AccrualImporterRow,
): AccrualImporterRow {
    const amount = computeAccrualLineAmount({
        quantity: row.quantity,
        unitPrice: row.unitPrice,
        amount: row.amount,
    });

    if (amount === row.amount) {
        return row;
    }

    return { ...row, amount };
}
